import { FormikErrors, useFormikContext } from "formik";
import { useRef, useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const useErrorBannerStyles = makeStyles(theme => ({
  errorAlert: {
    marginBottom: theme.spacing(3)
  }
}));

export default function FormikErrorBanner<Values = any>({
  renderBanner = () => "Please fix the errors indicated below.",
  noScrollOnError = false,
  additionalErrors
}: {
  renderBanner?: (errors: FormikErrors<Values>) => string | JSX.Element;
  noScrollOnError?: boolean;
  additionalErrors?: string | null;
} = {}): JSX.Element {
  const { submitCount, isValid, errors } = useFormikContext();
  const lastHandledRef = useRef(0);
  const [showBanner, setShowBanner] = useState(false);
  const classes = useErrorBannerStyles();

  useEffect(() => {
    if (submitCount > lastHandledRef.current && !isValid) {
      lastHandledRef.current = submitCount;
      if (!noScrollOnError) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      setShowBanner(true);
    }

    if (isValid) {
      setShowBanner(false);
    }
  }, [submitCount, isValid, noScrollOnError]);

  return (
    <div>
      {additionalErrors && (
        <Alert severity="error" className={classes.errorAlert}>
          {additionalErrors}
        </Alert>
      )}
      {showBanner ? (
        <Alert severity="error" className={classes.errorAlert}>
          {renderBanner(errors)}
        </Alert>
      ) : null}
    </div>
  );
}
